import { render, staticRenderFns } from "./china.vue?vue&type=template&id=4b865bd7&scoped=true&"
import script from "./china.vue?vue&type=script&lang=js&"
export * from "./china.vue?vue&type=script&lang=js&"
import style0 from "./china.vue?vue&type=style&index=0&id=4b865bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b865bd7",
  null
  
)

export default component.exports